import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import crypto from 'crypto'
import _ from 'underscore'

const SET_USER = 'SET_USER'
const SET_USER_ROLES = 'SET_USER_ROLES'
const SET_ENROLLMENT = 'SET_ENROLLMENT'
const UPDATE_ENROLLMENT = 'UPDATE_ENROLLMENT'
const STORE_ACCESS_TOKEN = 'STORE_ACCESS_TOKEN'
const LOGOUT = 'LOGOUT'
const SET_CF_TOKEN = 'SET_CF_TOKEN'

axios.defaults.baseURL = process.env.API_BASE || 'http://' + window.location.hostname + ':3000/'
Vue.use(VueAxios, axios)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('accessToken'),
    currentHproduct: localStorage.getItem('hproduct'),
    uidsigToken: localStorage.getItem('uidsigToken'),
    secret: process.env.SECRET,
    apptOpsHcos: [25849, 258550, 258552, 258554, 31, 32, 33, 241060, 241061, 241062, 241063],
    bookedHcos: [31, 32, 241060, 241061, 458728, 458729, 258549, 258550],
    phonedamentalsHcats: [88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 105, 107, 108, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 130, 131, 132, 197],
    negativeHcos: [10, 82, 87, 98, 46856, 46857, 56631, 56632, 91269, 91270, 91271, 241061, 241062, 241063, 532606, 532614, 743825, 770251,987655,987656,987657,987658,987659],
    calling: false,
    currentView: 'inbox',
    conversation: {},
    conversationOwner: {
      leuserid: 0,
      descrip1: "",
      avatar: ""
    },
    conversationid: 123,
    currentMessages: {},
    loadingConvo: false,
    loadingInbox: true,
    loadingMore: false,
    socketOn: 0,
    loadedAll: false,
    query45: false,
    currentConvoViewId: 0,
    textableLineInfo: {lineId: 0},
    selectedTextLine: 0,
    currentThread: {
      campaigns:[],
      conversationid: 1234,
      isLive: false,
      editMode: false,
      name: 'Customer',
      shortName: 'LS',
      phone: '',//111-444-5555',
      status: '',//Appt. May 30, 2018',
      audioState: 'new',
      lskinid: '',
      followers: [],
      followerCount: 0,
      messagesArray: [
        {
          date: '',
          inbound: false,
          isLiveBubble: false,
          type: 0,
          id: 34476375,
          editCode: '',
          handler: {
            name: '',
            firstName: '',
            shortName: '',
            avatarLink:'',
            lskin: 1
          },
          details: {
            outcome: '',
            negHCO: '',
            answerTime: 1,
            duration: '',
            recap: '',
            talkTime: 29,
            tlLabel: '',
            tlNumber: '',
            tlExt: '',
            account: ''
          },
          voicemail: null,
          audioLink: ''
        }
      ]
    },
    lskins: [],
    filteredLskins: [],
    selectedFilter: 'All Convos',
    selectedPhonecodeGroup: 0,
    waveformsArray: [],
    wavesurfer: undefined,
    accounts: [],
    account: {
      name: '',
      shortName: '',
      avatarLink: '',
      lskinid: 24,
      refname: '',
      leuserid: 12345,
      hproductid: 12,
      letimeadjust: 0, 
    },
    externalMapping: '0',
    agents: [],
    callCenterAgents: [],
    crmLinkService: '',
    crmLinkSales: '',
    showPop: false,
    liveListenDID: '',
    obCallerArray: [
      {
        name: '',
        lskin: 55
      }
    ],
    replyObj: {
      inbound: false,
      obCaller: null,
      type: 0,
      replyText: ''
    },
    recordMsgArray: [
      {
        name: '',
        audioLink: '' },
    ],
    resources: [],
    filteredResources: [],
    resourceTags: [],
    resourceTypeFilter: 'ANY',
    resourceNameFilter: '',
    tagFilters: {
      salesFilter: false,
      serviceFilter: false,
      partsFilter: false,
    },
    inboxData: [
      {
        name: '',
        custNumber: '',
        tlInfo: '',
        type: '',
        icon: '',
        sneak: '',
        lskinid: '',
        liveCall: true,
        unaddressed: false,
        selected: false,
        handledByMe: false,
        displayTime: '',
        lastCommsDate: '',
        conversationid: 123,
        interactionid: 1235568564
      }
    ],
    liveCallData: [],
    liveButton: true,
    conversationIdToLoad: 0,
    showUsagePopup: false,
    showReplyPopup: false,
    userProfileData: {
      name: '',
      phone: '',
      mobilePhone: '',
      directPhone: '',
      deskPhone: '',
      available: ''
    },
    sessionLogout: true,
    cdkData: {
      apptStatus: '',
      apptDate: '',
      apptTime: '',
      apptStatusCode: '',
      custName: 'Customer',
      advisorName: '',
      showElement: {
        showDate: false,
        showTime: false,
        showStatus: false,
        showAdvisor: false
      }
    },
    deepLinkConversationId: '',
    deepLinkExecuted: false,
    phonecodeGroups: {},
    phonecodesToGroupsMap: {},
    tosSet: false,
    seeTos: false,
    callCenterOutcomeFeatureEnabled: false,
    callCenterMasterLskin: undefined,
    callCenterOutcomes: [],
    linesToFilter: {},
    callCenterResources: [],
    customerConsent: undefined,
    resourcesEnabled: false,
    noteData: {
      notes: [],
      conditionals: {}
    },
    vinDealercodes: {},
    dsDealercodes: {},
    eleadDealercodes: {},
    jiveLskins: [],
    nexhealthLskins: [],
    callmeasurementAPIToken: undefined,
    unaddressedLogMap: {},
    campaigns: [],
    aniToCampaignMap: {},
    redactionEnabled: false
  },
  mutations: {
    setAniCampaignMap (state, payload) {
      state.aniToCampaignMap = payload;
    },
    setCampaignVisibility (state, payload) {
      state.campaigns[payload.index].visible = payload.value;
    },
    setCampaigns (state, payload) {
      state.campaigns = payload;
    },
    newConversation(state, payload){
      //used by campaigns to create conversations prior to making calls to customer
      state.currentThread.name = payload.name
      state.currentThread.type = payload.type
      state.currentThread.isLive = payload.isLive
      state.currentThread.phone = payload.phone
      state.currentThread.lskinid = payload.lskinid
      state.currentThread.custNumber = payload.custNumber
      state.currentThread.campaigns = payload.campaigns
    },
    noConversation(state){
      //used by campaigns when a campaign is finished or exited - returns live call mod to default state on load
      state.currentThread.audioState = "new"
      state.currentThread.conversationid = 1234
      state.currentThread.editMode = false
      state.currentThread.followerCount = 0
      state.currentThread.followers = []
      state.currentThread.isLive = false
      state.currentThread.lskinid = ""
      state.currentThread.messagesArray = []
      state.currentThread.name = "Customer"
      state.currentThread.phone = ""
      state.currentThread.shortName = "LS"
      state.currentThread.status = ""
      //these are only needed when going from campaign conversation to no conversation
      state.currentThread.campaigns = false
    },
    addUnaddressedLog (state, payload) {
      state.unaddressedLogMap[payload.CommunicationId] ? state.unaddressedLogMap[payload.CommunicationId].unshift(payload) : Vue.set(state.unaddressedLogMap, payload.CommunicationId, [payload]);
    },
    storeUnaddressedLog (state, payload) {
      state.unaddressedLogMap = payload;
    },
    setCallmeasurementAPIToken (state, payload) {
      state.callmeasurementAPIToken = payload;
    },
    markMessagesAddressed (state, payload) {
      state.currentMessages = payload;
    },
    markDeepLinkExecuted (state) {
      state.deepLinkExecuted = true;
    },
    setVinDealercodeMappings (state, payload) {
      state.vinDealercodes = payload;
    },
    setDSDealercodeMappings(state, payload) {
      state.dsDealercodes = payload;
    },
    setEleadDealercodeMappings(state, payload) {
      state.eleadDealercodes = payload;
    },
    setJiveLskins (state, payload) {
      state.jiveLskins = payload;
    },
    setNexhealthLskins (state, payload) {
      state.nexhealthLskins = payload;
    },
    setNoteData (state, payload) {
      state.noteData = payload;
    },
    setTrackingLineFilters (state, payload) {
      state.linesToFilter = payload.lines;
    },
    setResourceFlag (state, payload) {
      state.resourcesEnabled = payload.isEnabled;
    },
    setRedactionFlag (state, payload) {
      state.redactionEnabled = payload.isEnabled;
    },
    setCallCenterOutcomeFeature (state, payload) {
      state.callCenterOutcomeFeatureEnabled = payload.isEnabled;
    },
    setCallCenterOutcomes (state, payload) {
      state.callCenterOutcomes = payload.outcomes;
    },
    storeConsent (state, payload) {
      state.customerConsent = payload.consent;
    },
    setCallCenterMasterLskin (state, payload) {
      state.callCenterMasterLskin = payload.lskin;
    },
    setPhonecodesToGroupsMap (state, payload) {
      state.phonecodesToGroupsMap = payload.phonecodesToGroupsMap;
    },
    setPhonecodeGroups (state, payload) {
      state.phonecodeGroups = payload.phonecodeGroups;
    },
    setDeepLinkConversationId (state, payload) {
      state.deepLinkConversationId = payload.id;
    },
    setCallingStatus (state, payload) {
      state.calling = payload.mode
    },
    setAvailabilityFromRedis (state, payload) {
      state.userProfileData.available = payload.available;
    },
    updateResources (state, payload) {
      if (state.callCenterMasterLskin != state.account.lskinid) {
        payload.resources = [...payload.resources, ...state.callCenterResources]
      }
      payload.resources.forEach((part, index) => {
        part.display = true
        // console.log(part)
        part.tags.forEach((tag) => {
          if (tag.ResourceTagName.Name === 'Sales') {
            state.tagFilters.salesFilter = true
          } else if (tag.ResourceTagName.Name === 'Service') {
            state.tagFilters.serviceFilter = true
          } else if (tag.ResourceTagName.Name === 'Parts') {
            state.tagFilters.partsFilter = true
          }
        })
      });
      state.resources = payload.resources
    },
    updateResourceTagFilter(state, payload) {
      if (state.resourceTags.indexOf(payload.tag) > -1) {
        state.resourceTags.splice(state.resourceTags.indexOf(payload.tag), 1)
      } else {
        state.resourceTags.push(payload.tag)
      }
    },
    updateResourceTypeFilter(state, payload) {
      state.resourceTypeFilter = payload.resourceType
    },
    updateResourceNameFilter(state, payload) {
      state.resourceNameFilter = payload.search
    },
    removeResourceFilters(state, payload) {
      for (var i = 0; i < state.resources.length; i++) {
        state.resources[i].display = true
      }
    },
    updateFilteredResources (state, payload) {
      let tempResources = []
      for (var i = 0; i < state.resources.length; i++) {
        let rem = false
        state.resources[i].tags.forEach((tag) => {
          if (state.resourceTags.includes(tag.ResourceTagName.Name)) {
            rem = true
          }
        })

        if (state.resourceTypeFilter != 'ANY' && state.resources[i].ResourceType != state.resourceTypeFilter) {
          rem = true
        }

        if (state.resourceNameFilter != "" && !state.resources[i].Name.toLowerCase().includes(state.resourceNameFilter.toLowerCase())) {
          rem = true
        }

        if (!rem) {
          tempResources.push(state.resources[i])
        }
      }

      state.filteredResources = tempResources
    },
    updateCallCenterResources (state, payload) {
      state.callCenterResources = payload.resources
    },
    updateUserName (state, payload) {
      state.userProfileData.name = payload.name;
    },
    updateUserPhone (state, payload) {
      state.userProfileData.phone = payload.phone;
    },
    updateUserMobilePhone (state, payload) {
      state.userProfileData.mobilePhone = payload.mobilePhone;
    },
    updateUserDeskPhone (state, payload) {
      state.userProfileData.deskPhone = payload.deskPhone;
    },
    updateUserDirectPhone (state, payload) {
      state.userProfileData.directPhone = payload.directPhone;
    },
    updateUserStatus (state, payload) {
      state.userProfileData.available = payload.available;
    },
    updateCurrentAccount (state, payload) {
      state.account = state.accounts[payload.account]
    },
    setAccounts (state, payload) {
      state.accounts = payload.accounts
    },
    setUsagePopup (state, payload) {
      state.showUsagePopup = payload.showUsagePopup;
      state.showReplyPopup = payload.showReplyPopup
    },
    setCDKData (state, payload) {
      state.cdkData.apptStatus = payload.apptStatus;
      state.cdkData.apptDate = payload.apptDate;
      state.cdkData.apptTime = payload.apptTime;
      state.cdkData.showElement.showDate = payload.date;
      state.cdkData.showElement.showTime = payload.time;
      state.cdkData.showElement.showStatus = payload.status;
      state.cdkData.apptStatusCode = payload.apptStatusCode;
      state.cdkData.advisorName = payload.advisorName;
      state.cdkData.showElement.showAdvisor = payload.advisor;
    },
    setCDKName (state, payload) {
      state.cdkData.custName = payload.custName;
    },
    setSelectedPhonecodeGroup (state, payload) {
      state.selectedPhonecodeGroup = payload.selectedPhonecodeGroup;
    },
    setSelectedFilter (state, payload) {
      state.selectedFilter = payload.selectedFilter
    },
    setSessionLogout (state, payload) {
      state.sessionLogout = payload.sessionLogout;
    },
    updateFilteredLskins (state, payload) {
      state.filteredLskins = payload.lskinArray
    },
    setLskins (state, payload) {
      state.lskins = payload.lskins;
      state.filteredLskins = payload.lskins;
    },
    async setCallCenterAgents (state, payload) {
      let lskins = payload.lskins;
      let endpoint = '/accounts/';
      let agentsPromises = []
      let agentsArray = []

      for (let i = 0; i < lskins.length; i++) {
        let lskin = lskins[i]
        let url = endpoint + lskin + '/users?phonecode'
        agentsPromises.push(axios.get(url, { responseType: 'json' })) 
      }
      
      Promise.all(agentsPromises).then((results) => {
        results.forEach(function (part, index, arr) {
          part.data.forEach(function (part, index, arr) {
            if (part.Phonecode && part.Phonecode.pc_avatar) {
              arr[index].Phonecode.pc_avatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${part.Phonecode.phonecodeid}.jpg`
            }
            agentsArray.push(arr[index])
          })
        })
      })

      state.callCenterAgents = agentsArray
    },
    async asyncSummaries (state, payload) {
      let endpoint = `conversations/summaryAsync`

      let res = await axios.post(endpoint, {
        callids: payload.callids
      });

      let summaries = res.data;
      for(const [index, obj] of this.state.currentMessages.entries()) {
        if (summaries[obj.callid]) {
          state.currentMessages[index].call_summ = summaries[obj.callid]
        }
      }
    },
    async asyncDetails (state, payload) {
      let endpoint = `conversations/detailsAsync`

      let res = await axios.post(endpoint, {
        callids: payload.callids
      });

      if (res.data) {
        let details = res.data;
        for(const [index, obj] of this.state.currentMessages.entries()) {
          if (details[obj.callid]) {
            // Foreign language translation values
            state.currentMessages[index].review_classid = details[obj.callid].review_classid;
          }
        }
      }
    },
    async setFollowers (state, payload) {
      let conversationid = payload.conversationid;
      let endpoint = 'conversations/' + conversationid + '/followers';
      let results = await axios.get(endpoint);
      if (results && results.data) {
        state.currentThread.followerCount = results.data.length;
        state.currentThread.followers = results.data;
        for (let i = 0; i < state.currentThread.followers.length; i++) {
          if (state.user.leuserid == state.currentThread.followers[i].leuserid) {
            state.currentThread.userIsFollowing = true;
            break;
          }
        }
      }
    },
    async getOwner (state, payload) {
      let userid = payload.userid;
      let endpoint = 'users/' + userid;
      let res = await axios.get(endpoint);
      let data = res.data;
      if (data[0]) {
        state.conversationOwner = data[0];
      }
    },
    async setOwner (state, payload) {
      let userid = parseInt(payload.userid);
      let conversationid = payload.conversationid;
      let newOwner = payload.newOwner;
      let endpoint = 'conversations/' + conversationid + '/owner';

      let res = await axios.post(endpoint, {
        userid: userid
      });
      let data = res.data;
      state.conversation.conversation.ownerId = userid
      state.conversationOwner = newOwner;
      // console.log(newOwner)
    },
    async setAddressed (state, payload) {
      let conversationid = payload.conversationid;
      let endpoint = 'conversations/' + conversationid + '/addressed';

      let res = await axios.post(endpoint);
    },
    async addFollower (state, payload) {
      let conversationid = payload.conversationid;
      let userid = payload.userid;
      let newFollower = payload.newFollower;
      let endpoint = 'conversations/' + conversationid + '/followers/add';

      // Add permissions check ( can't remove other users )
      let res = await axios.post(endpoint, {
        userid: userid,
        conversationid: conversationid
      });
      let data = res.data;
      if (data) {
        state.currentThread.followers.push(newFollower);
        state.currentThread.followerCount++;
        if (userid == state.user.leuserid) {
          state.currentThread.userIsFollowing = true;
        }
      }
    },
    async removeFollower (state, payload) {
      let conversationid = payload.conversationid;
      let userid = payload.userid;
      let endpoint = 'conversations/' + conversationid + '/followers/remove';

      let res = await axios.post(endpoint, {
        userid: payload.userid,
        conversationid: payload.conversationid
      });

      let data = res.data;
      if (data) {
        for(var i = 0; i < state.currentThread.followers.length; i++) {
          if(state.currentThread.followers[i].leuserid == userid) {
            state.currentThread.followers.splice(i, 1);
            break;
          }
        }
        state.currentThread.followerCount--;
        if (state.user.leuserid === userid) {
          state.currentThread.userIsFollowing = false;
        }
      } 
    },
    setFollowerCount (state, payload) {
      state.currentThread.followerCount = payload.followerCount;
    },
    setHproduct (state, payload) {
      state.currentHproduct = payload.hproduct;
      localStorage.setItem('hproduct', payload.hproduct);
    },
    setUidsigToken (state, payload) {
      state.uidsigToken = payload.uidsigToken;
      localStorage.setItem('uidsigToken', payload.uidsigToken);
    },
    addMessage (state, payload) {
      state.currentMessages.push(payload.message)
      state.currentMessages = state.currentMessages.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date)
      })
    },
    turnSocketOn (state) {
      state.socketOn++;
    },
    updateCurrentThread (state, payload) {
      state.currentThread.name = payload.name
      state.currentThread.type = payload.type
      state.currentThread.conversationid = payload.conversationid
      state.currentThread.editMode = payload.editMode
      state.currentThread.shortName = payload.shortName
      state.currentThread.isLive = payload.isLive
      state.currentThread.phone = payload.phone
      state.currentThread.status = payload.status
      state.currentThread.contact = payload.contact
      state.currentThread.recentType = payload.recentType
      state.currentThread.audioState = payload.audioState
      state.currentThread.lskinid = payload.lskinid
      state.currentThread.custNumber = payload.custNumber
    },
    clearInbox (state) {
      state.inboxData = []
    },
    loadInbox (state, payload) {
      if (payload.setting) {
        state.inboxData = state.inboxData.filter(item => item.liveCall)
      }
      state.loadingInbox = payload.setting
    },
    loadMoreInbox (state, payload) {
      state.loadingMore = payload.setting
    },
    addToInbox (state, payload) {
      state.inboxData.push(payload.message)
    },
    replaceInbox (state, payload) {
      state.inboxData = payload.message
    },
    sortInbox (state) {
      let liveItems = state.inboxData.filter((obj) => { return obj.liveCall })
      let otherItems = state.inboxData.filter((obj) => { return !obj.liveCall })

      function sortDate (a, b) {
        return new Date(b.lastCommsDate) - new Date(a.lastCommsDate)
      }

      state.inboxData = [...liveItems.sort(sortDate), ...otherItems.sort(sortDate)]
    },
    query45days (state, payload) {
      state.query45 = payload.setting;
    },
    hideLiveButton (state, payload) {
      state.liveButton = payload.setting;
    },
    loadAll (state, payload) {
      state.loadedAll = payload.setting;
    },
    addToLiveCall (state, payload) {
      state.liveCallData.push(payload.message)
    },
    removeLiveCall (state, payload) {
      // Mark conversation is completed, and then remove from liveCallData array
      let callPos = state.inboxData.findIndex(obj => obj.interactionid === payload.message.interactionid)
      let popLiveCallData = state.liveCallData.filter(obj => obj.interactionid !== payload.message.interactionid)

      state.liveCallData = popLiveCallData

      if (callPos >= 0) {
        state.inboxData[callPos].liveCall = false

        if (state.currentThread.conversationid === state.inboxData[callPos].conversationid) {
          state.currentThread.isLive = false
          state.currentMessages[state.currentMessages.length-1].islive = false
        }
      }
    },
    removeLiveCallEntirely (state, payload) {
      // Mark conversation is completed, and then remove from liveCallData array AND remove from inbox
      let callPos = state.inboxData.findIndex(obj => obj.interactionid === payload.message.interactionid)
      let popLiveCallData = state.liveCallData.filter(obj => obj.interactionid !== payload.message.interactionid)
      let popInboxData = state.inboxData.filter(obj => obj.interactionid !== payload.message.interactionid);

      state.liveCallData = popLiveCallData;
      
      if (callPos >= 0) {
        state.inboxData[callPos].liveCall = false

        if (state.currentThread.conversationid === state.inboxData[callPos].conversationid) {
          state.currentThread.isLive = false
          state.currentMessages[state.currentMessages.length-1].islive = false
        }
      }

      state.inboxData = popInboxData;
    },
    replaceConversationById (state, payload) {
      // Make sure we retain some state when this happens
      let currentConvo = state.inboxData.filter(obj => obj.conversationid === payload.conversationid)[0]
      if(currentConvo && currentConvo.conversationid === payload.conversationid) { 
        payload.selected = currentConvo.selected; 
        payload.unaddressed = currentConvo.unaddressed;
      }
      state.inboxData[state.inboxData.findIndex(obj => obj.conversationid === payload.conversationid)] = payload
    },
    loadConversation (state, payload) {
      if (payload.setting) {
        state.conversation = {}
        state.conversationOwner = {
          leuserid: 0,
          descrip1: "",
          avatar: ""
        }
        state.currentMessages = []
        state.currentThread.userIsFollowing = false;
      }
      state.loadingConvo = payload.setting
    },
    removeOldestItem (state) {
      state.inboxData.sort((a, b) => new Date(b.lastCommsDate) - new Date(a.lastCommsDate)).pop()
    },
    AddLiveCallToConversation (state, payload) {
      let live = {}
      if (state.liveCallData.length) {
        live = state.liveCallData.filter((obj) => { return obj.conversationid === payload.conversationid })
      }

      let direction = live.type === 'IB' ? 1 : 2

      if (live.length) {
        live = live[0]
        state.currentThread.isLive = live.liveCall

        let phonecodeObject = {};
        let agentObject = {};
        if (live.conversation.interaction.call.phonecodeid > 0) {
          phonecodeObject = {
            lename: live.conversation.interaction.call.lename,
            pc_avatar: live.conversation.interaction.call.pc_avatar ? `https://s3.amazonaws.com/callbox-images-external/avatars/${live.conversation.interaction.call.phonecodeid}.jpg` : live.conversation.interaction.call.pc_avatar,
            phonecodeid: live.conversation.interaction.call.phonecodeid
          }
          agentObject = {
            'Phonecode': phonecodeObject
          }
        } else {
          phonecodeObject = null;
          agentObject = null;
        }

        state.currentMessages.push({
          agent: agentObject,
          agentSelected: agentObject,
          ani: live.custNumber,
          audio: {
            audiofile: '',
            audiofileembed: '',
            recording_killed: false
          },
          audioCompression: null,
          callid: live.interactionid,
          cf_frn_dnisid: live.conversation.interaction.call.dnisId,
          date: moment(live.lastCommsDate).format('MMMM D, YYYY'),
          datetime: moment(live.lastCommsDate).format('MMMM D, YYYY h:mm A'),
          disposition: 'Answered',
          disposition_condensed: live.conversation.hcatCondensed === 'no recap' ? '' : live.conversation.hcatCondensed,
          displaynum: live.displayNum,
          dnis: {
            displaynum: live.displayNum,
            dnisfunctionid: direction,
            label1: live.tlInfo
          },
          dnis_extension: live.conversation.interaction.call.bridgeval,
          dnis_ringto: '',
          dnisfunctionid: live.type === 'IB' ? 1 : 2,
          duration: '',
          extension_frn_dnisid: live.conversation.interaction.call.extension,
          frn_xcall_dispositionid: 1,
          frn_phonecodeid: live.conversation.interaction.call.phonecodeid,
          lename: live.conversation.interaction.call.lename,
          islive: live.liveCall,
          inbound: (live.type === 'IB'),
          label1: live.conversation.dnisLabel,
          lednis: '',
          leminutes: '',
          pc_avatar: live.conversation.interaction.call.pc_avatar ? `https://s3.amazonaws.com/callbox-images-external/avatars/${live.conversation.interaction.call.phonecodeid}.jpg` : live.conversation.interaction.call.pc_avatar,
          spamrating: '',   
          note: null,
          sentimentNeg: false,
          sentimentPos: false,
          transcript: '',
          type: 1,
          nodeIP: live.conversation.interaction.call.asteriskIP
        })
      }
    },
    AddTextToConversation (state, payload) {
      state.currentMessages.push({
        frn_zwid: payload.frn_zwid,
        body: payload.body,
        inbound: payload.direction == 'inbound' ? true : false,
        datetime: moment(payload.datetime).format('LLL'),
        agent:{
          Phonecode:{
              lename: payload.lename,
              pc_avatar: payload.pc_avatar ? `https://s3.amazonaws.com/callbox-images-external/avatars/${payload.phonecodeid}.jpg` : '',
            }
          },
        label1: payload.label1,
        displaynum: payload.displaynum,
        id: payload.id,
        forwardedTo: payload.forwardedTo,
        sendStatus: payload.isSent,
        attachment: payload.attachment
      })
    },
    AddNoteToConversation (state, payload) {
      // console.log(payload)
      state.currentMessages.push({
        comment: payload.comment,
        User: {
          leuserid: payload.leuserid,
          descrip1: payload.username,
          phonecodeid: payload.phonecodeid,
          pc_avatar: payload.pc_avatar
        },
        formattedDate: moment(payload.timestamp).format('LLL'),
        type: 4
      })
    },
    updateConversation (state, payload) {
      state.conversation = payload.conversation
    },
    updateConversationData (state, payload) {
      if (payload.conversation.conversation.conversationid == state.conversationIdToLoad) {
        payload.conversation.interactions.sort(function (a, b) {
          if (a.tz_datetime && b.tz_datetime) {
            return new Date(a.tz_datetime) - new Date(b.tz_datetime)
          } else if (a.datetime && b.datetime) {
            return new Date(a.datetime) - new Date(b.datetime)
          }
        })
        state.conversation = payload.conversation.conversation
        state.currentMessages = payload.conversation.interactions
        this.commit('getOwner', { userid: state.conversation.conversation.ownerId })
        this.commit('setAddressed', { conversationid: state.conversation.conversation._id })
      } else {
      }
    },
    trackConvoId (state, payload) {
      state.conversationIdToLoad = payload.conversationId
    },
    updateAccountData (state, payload) {
      state.account = payload.account
    },
    updateLiveListenDID (state, payload) {
      state.liveListenDID = payload.newDID
    },
    updateAgentsData (state, payload) {
      payload.users.sort(function (a, b) {
        return a.Phonecode.lename === b.Phonecode.lename ? 0 : a.Phonecode.lename < b.Phonecode.lename ? -1 : 1
      })
      state.agents = payload.users
    },
    updateMessages (state, payload) {
      payload.messages.sort(function (a, b) {
        return new Date(a.date) - new Date(b.date)
      })
      state.currentMessages = payload.messages
    },
    updateCrmLink (state, payload) {
      state.crmLinkService = payload.serviceLink
      state.crmLinkSales = payload.salesLink
    },
    updateConvoViewId (state, payload) {
      state.currentConvoViewId = payload.id
    },
    updateExternalMapping (state, payload) {
      state.externalMapping = payload.value
    },
    updateValidTextLines (state, payload) {
      state.textableLineInfo = payload.id
    },
    updateSelectedTextLine (state, payload) {
      state.selectedTextLine = payload.lineObj
    },
    callPop (state, payload) {
      state.replyObj.obCaller = state.obCallerArray[0]
      state.replyObj.date = payload.date
      state.replyObj.type = 0
      state.showPop = true
    },
    textPop (state, payload) {
      state.replyObj.date = payload.date
      state.replyObj.type = 1
      state.showPop = true
    },
    voicePop (state, payload) {
      state.replyObj.date = payload.date
      state.replyObj.type = 2
      state.replyObj.selectedMessage = state.recordMsgArray[0]
      state.replyObj.audioiLink = state.replyObj.selectedMessage.audioLink
      state.conversation.audioState = 'new'
      state.showPop = true
    },
    hidePopup (state) {
      state.showPop = false
    },
    playPauseAudio (state, payload) {
      state.waveformsArray[payload.index].playPause()
    },
    LOGIN (state) {
      state.pending = true
    },
    LOGIN_SUCCESS (state) {
      state.isLoggedIn = true
      state.pending = false
    },
    LOGOUT (state) {
      state.user = null
      state.accessToken = null
      localStorage.removeItem('accessToken')
      localStorage.removeItem('hproduct')
      localStorage.removeItem('lskins')
      localStorage.removeItem('acceptedTos')
      localStorage.removeItem('uidsigToken')
    },
    SET_USER (state, payload) {
      state.user = payload.user
      state.account.lskinid = payload.user.frn_lskinid
      
      if (payload.user.Phonecode && payload.user.Phonecode.pc_avatar) {
        state.user.Phonecode.pc_avatar = `https://s3.amazonaws.com/callbox-images-external/avatars/${payload.user.Phonecode.phonecodeid}.jpg`
      }
    },
    SET_ENROLLMENT (state, payload) {
      if (localStorage.getItem('acceptedTos') === "true") {
        state.user.BiometricEnrollment = payload
        state.tosSet = true
        state.seeTos = true
      } else if (payload == null) {
        state.user.BiometricEnrollment = null
        state.tosSet = false
        state.seeTos = false
      } else {
        localStorage.setItem("acceptedTos", true)
        state.user.BiometricEnrollment = payload
        state.tosSet = true
        state.seeTos = true
      }
    },
    UPDATE_ENROLLMENT (state, payload) {
      if (payload.accept === true) {
        state.tosSet = payload.accept
        state.seeTos = payload.accept
      } else {
        state.tosSet = false 
        state.seeTos = false 
      }
    },
    STORE_ACCESS_TOKEN (state, accessToken) {
      state.accessToken = accessToken
      localStorage.setItem('accessToken', accessToken)
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
    },
    SET_CF_TOKEN (state, data) {
      state.cftoken = data.cftoken
      state.cfid = data.cfid
    },
    async SET_USER_ROLES (state, payload) {
      let userid = payload.userid;
      let endpoint = 'users/' + userid + '/roles';

      let res = await axios.get(endpoint);
      state.user.roles = res.data;
      state.user.isManager = false;

      const managerRoles = ["manager", "director", "owner"];
      for (let i = 0; i < state.user.roles.length; i++) {
        if (managerRoles.some(el => state.user.roles[i].contact_role.includes(el.toLowerCase()))) {
          state.user.isManager = true;
          break;
        }
      }

      if (state.user.access_admin === 1) {
        state.user.isManager = true;
      }
    }
  },
  getters: {
    filterLines (state) {
      if (Object.keys(state.linesToFilter).length) {
        return true;
      } else {
        return false;
      }
    },
    getFullAgentList (state) {
      let user = state.user;
      let agents = state.agents;
      let agentids = agents.map(x => x.leuserid);
      let callCenterAgents = state.callCenterAgents.filter(callcenterAgent => agentids.indexOf(callcenterAgent.leuserid) == -1);
      Array.prototype.push.apply(agents, callCenterAgents);
      agents = agents.filter(agent => agent.lskinid === user.lskinid)
			return agents.sort(function(a, b) {
        if (!a.descrip1) { 
          return 1
        } else if (!b.descrip1) { 
          return -1
        } else {
          var textA = a.descrip1.toUpperCase();
          var textB = b.descrip1.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        }
			});
    },
    getTosSet (state) {
      return state.tosSet
    },
    getSeeTos (state) {
      return state.seeTos
    },
    user (state) {
      return state.user
    },
    userProfileData (state) {
      return state.userProfileData
    },
    accessToken (state) {
      return state.accessToken
    },
    lskins (state) {
      // If this is a string, then split it and turn into an array
      // Else if undefined/null, or if its already an array just return
      if (state.lskins && !Array.isArray(state.lskins)) {
        return state.lskins.split(',');
      } else {
        return state.lskins;
      }
    },
    filteredLskins (state) {
      // If this is a string, then split it and turn into an array
      // Else if undefined/null, or if its already an array just return
      if (state.filteredLskins && !Array.isArray(state.filteredLskins)) {
        return state.filteredLskins.split(',');
      } else {
        return state.filteredLskins;
      }
    },
    multiAccount (state) {
      if (state.lskins && !Array.isArray(state.lskins)) {
        let lskins = state.lskins.split(',');
        if (lskins.length > 1) {
          return true;
        } else {
          return false;
        }
      } else if (state.lskins && Array.isArray(state.lskins) && state.lskins.length > 1){
        return true; 
      } else {
        return false;
      }
    },
    mxYouLink (state) {
      // This currently doesn't work because of header.cfm, gonna have to make changes to that to allow requests from callbox
      const hproduct = state.currentHproduct;
      let link;
      if (hproduct == 2) {
        link = '//platform.callbox.com.com';
      } else if (hproduct == 3) {
        link = '//service.carwars.com';
      } else if (hproduct == 4) {
        link = '//calltrackeronline.com';
      } else if (hproduct == 6) {
        link = '//callmeasurement.com';
      } else if (hproduct == 7) {
        link = '//rentbuzz.com';
      } else if (hproduct == 9) {
        link = '//servicehook.com';
      } else /* hproduct IN (1,10,11,12) */ {
        link = '//carwars.com';
      }
      // the platform no longer accepts an identity on the URL: it takes the signed uidsig
      // token minted for this user at login and ignores any userid we send. without a token
      // there is no link to build, and returning null leaves the anchor without an href
      // rather than sending the user to a request the platform will reject by logging out.
      if (!state.uidsigToken) {
        return null
      }
      let generatedLink = `${link}/platform_a/call_box_session.cfm?uidsig=${encodeURIComponent(state.uidsigToken)}&hproduct=${state.currentHproduct}&lskin=${state.account.lskinid}`
      return generatedLink
    }
  },
  actions: {
    async login ({ commit, dispatch }, creds) {
      commit('LOGIN')
      try {
	      let body = {
          userid: creds.userid,
          lskinid: creds.lskinid
        }
        let axiosConfig = {
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        }
        const response = await axios.post('/auth', body, axiosConfig)
        if (creds.cftoken && creds.cfid) {
          await dispatch('setCftoken', {cftoken: creds.cftoken, cfid: creds.cfid})
        }
        return await dispatch('setUserAndTokens', {accessToken: response.data.accessToken})
        commit(SET_USER_ROLES, { userid: creds.userid })
      } catch (err) {
        throw new Error(err)
      }
    },
    logout ({ commit, dispatch }) {
      try {
        commit(LOGOUT)
      } catch (err) {
        throw new Error(err)
      }
    },
    async setUserAndTokens ({ commit, dispatch, getters, rootGetters }, data) {
      try {
        let decoded = jwtDecode(data.accessToken)
        decoded.data.user.exp = decoded.exp * 1000
        commit(SET_USER, decoded.data)
        commit(SET_USER_ROLES, { userid: decoded.data.user.leuserid })
        commit(STORE_ACCESS_TOKEN, data.accessToken)
        commit(SET_USER, decoded.data)
        commit(SET_ENROLLMENT, decoded.data.user.BiometricEnrollment)
      } catch (err) {
        throw new Error(err)
      }
    },
    async setCftoken ({ commit, dispatch, getters, rooteGetters }, data) {
      try {
        commit(SET_CF_TOKEN, data)
      } catch (err) {
        throw new Error(err)
      }
    },
    async updateEnrollment ({ commit, dispatch, getters, rootGetters }, data) {
      try {
        let endpoint = '/users/'
        endpoint = endpoint + data.leuserid + '/enrollment'
        await axios.post(endpoint, {
          phonecodeid: data.phonecodeid
        })
        commit(SET_ENROLLMENT, {
          leuserid: data.leuserid,
          phonecodeid: data.phonecodeid,
          agreement_accepted: new Date()
        })
        commit(UPDATE_ENROLLMENT, { accept: data.accept })
      } catch (err) {
        throw new Error(err)
      }
    },
    async getUserProfileData ({commit, state}, phonecodeid) {
      return new Promise ( async (resolve, reject) => {
        try {
          let endpoint = '/users/'
          endpoint = endpoint + phonecodeid + '/getProfileData'
    
          let res = await axios.get(endpoint);
    
          if (res.data) {
            let phoneNumber = res.data.PhonecodeInstanceProfile ? res.data.phone : '';
            let mobilePhone = res.data.PhonecodeInstanceProfile ? res.data.PhonecodeInstanceProfile.mobile_number : '';
            let deskPhone = res.data.PhonecodeInstanceProfile ? res.data.PhonecodeInstanceProfile.DeskNumber : '';
            let directPhone = res.data.PhonecodeInstanceProfile ? res.data.PhonecodeInstanceProfile.direct_number : '';

            commit({
              type: 'updateUserName',
              name: res.data.lename
            })
            commit({
              type: 'updateUserPhone',
              phone: phoneNumber
            })
            commit({
              type: 'updateUserMobilePhone',
              mobilePhone: mobilePhone
            })
            commit({
              type: 'updateUserDeskPhone',
              deskPhone: deskPhone
            })
            commit({
              type: 'updateUserDirectPhone',
              directPhone: directPhone
            })

            let redisEndpoint = '/users/'
            redisEndpoint = redisEndpoint + phoneNumber + '/getRedisAvailability'
            let redisRes = await axios.get(redisEndpoint)
    
            if (redisRes) {
              // Not in set
              if (redisRes.data === 0) {
                commit({
                  type: 'updateUserStatus',
                  available: 1
                })
              } else {
                commit({
                  type: 'updateUserStatus',
                  available: 0
                })
              }
            } else {
              commit({
                type: 'updateUserStatus',
                available: res.data.currently_available
              })
            }
          }
          resolve();
        } catch(err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async joinACall ({ commit, state }, data) {
      commit({
        type: 'setCallingStatus',
        mode: true
      })

      const endpoint = '/joinACall'
      await axios.post(endpoint, {
        callid: data.callid,
        phoneNumber: data.phoneNumber,
        joinType: data.joinType,
        nodeIp: data.nodeIp
      })

      commit({
        type: 'setCallingStatus',
        mode: false 
      })
    },
    displayMessage ({commit, state}, message) {
      if (message.custNumber !== '' && typeof message.conversationid !== 'undefined') {
        let accountConvo = state.inboxData.filter((obj) => { return obj.conversationid === message.conversationid })

        const latestInteractionType = message.conversation.interaction.type;
        const conversationPhonecode = message.conversation.interaction[latestInteractionType.toLowerCase()].phonecodeid;
        const isManager = state.liveButton;
        const userHandling = state.user.Phonecode ? conversationPhonecode == state.user.Phonecode.phonecodeid : false;
        const groupMemberHandling = state.selectedPhonecodeGroup 
          && state.phonecodesToGroupsMap[conversationPhonecode] 
          && state.phonecodesToGroupsMap[conversationPhonecode].length 
            ? state.phonecodesToGroupsMap[conversationPhonecode].includes(state.selectedPhonecodeGroup) 
            : false;

        /*
          We do live calls filtering logic on all of our websocket messages (live calls, completed calls).
          Why don't we just filter them out entirely upstream? We need a safeguard against completed calls that pair with live calls that get filtered out.
          So we could have live calls stack up and never get completed on the FE, in Mongo they'd be fine.

          The filter rules are based on handled by and user logged in role as well as having special rules if a manager if filtering for phonecode groups.
          Generally all non managers will always only see their own calls (HANDLED BY) or unknown handler calls.
          All managers will see everything UNLESS they pick a phonecode group filter. In which case they'll only see own calls, unknown handler, and group handled calls.
        */
       
        let displayThisCall = false;
        if (!isManager) {

          // If user handling or unknown handler, display
          if (userHandling || !conversationPhonecode) {
            displayThisCall = true;
          }

        } else if (isManager) {
          
          // If manager has selected a group filter and member of staff group is handling, or manager is handling, or unknown handler, display
          if (state.selectedPhonecodeGroup) {

            if (groupMemberHandling || userHandling || !conversationPhonecode) {
              displayThisCall = true;
            }

          // If manager is not filtering for staff groups, display everything
          } else {

            if (userHandling || !conversationPhonecode) {
              displayThisCall = true;
            }
            
          }
        }

        // User following
        if (state.selectedFilter === 'Following & New') {
          if (message.conversation.followers && message.conversation.followers.length && message.conversation.followers.indexOf(state.user.leuserid) !== -1) {
            displayThisCall = true;
          }
        }

        // Unaddressed
        if (state.selectedFilter === 'Unaddressed') {
          if (message.conversation.containsUnaddressed) {
            displayThisCall = true;
          }
        }

        // Exception for 'all convos' filter
        if (state.selectedFilter === 'All Convos') {
          displayThisCall = true;
        }

        if(message.liveCall) { 

          if (displayThisCall) {

            commit({
              type: 'addToLiveCall',
              message: message
            })

          }

        } else {

          if (displayThisCall) {

            commit({
              type: 'removeLiveCall',
              message: message
            })

          } else {

            commit({
              type: 'removeLiveCallEntirely',
              message: message
            })

          }

        }

        if (accountConvo.length) {

          if (displayThisCall) {
            commit('replaceConversationById', message)
          }

          if (state.currentThread.conversationid === message.conversationid && message.liveCall) {
            commit({
              type: 'AddLiveCallToConversation',
              conversationid: message.conversationid
            })
          }

        } else {

          if (state.inboxData.length >= 200) {
            commit('removeOldestItem'); 
          }

          if (displayThisCall) {
            commit({
              type: 'addToInbox',
              message: message
            })
          }
          
        }

        commit('sortInbox') 
      }
    },
    async addNote ({ commit, state }, payload) {
      let endpoint = '/conversations/';
      let url = `${endpoint}${payload.conversationid}/notes/add`;
      let res = await axios.post(url, {
        conversationid: payload.conversationid,
        comment: payload.content,
        leuserid: payload.leuserid,
        taggedUser: payload.taggedUser,
        phonecodeid: payload.phonecodeid,
        pc_avatar: payload.pc_avatar,
        username: payload.username,
        timestamp: payload.time
      });

      return res;
    },
    getCallCenterLskins ({commit, state, dispatch}, payload) {
      return new Promise ( async (resolve, reject) => {
        try {
          // Keep track of master account
          commit({
            type: 'setCallCenterMasterLskin',
            lskin: payload.lskinid
          })

          await dispatch('populateCallCenterResourcesAsync', payload.lskinid)

          let endpoint = '/accounts/';
          let url = endpoint + payload.lskinid + '/callcenter'
          let res = await axios.get(url);
    
          if (Array.isArray(res.data) && res.data.length > 0) {
            console.log('This is a call center master account.');

            commit({
              type: 'setLskins',
              lskins: res.data
            })
    
            commit({
              type: 'setCallCenterAgents',
              lskins: [payload.lskinid]
            })
          } else {
            console.log('This is NOT a call center master account.');
            commit({
              type: 'setLskins',
              lskins: payload.lskinid
            })
          }
  
          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async checkUsagePolicy ({commit, state}, data) {
      return new Promise ( async (resolve, reject) => {
        try {
          let endpoint = `/users/${state.user.leuserid}/textUsage`
          let res = await axios.get(endpoint)

          if (res.data) {
            if (res.data[0]) {
              state.showUsagePopup = false
              state.showReplyPopup = true
            } else {
              state.showUsagePopup = true
              state.showReplyPopup = false
            }
          }

          resolve();
        } catch(err) {
          console.log(err);
          reject(err);
        }
      })
    },
    getPhonecodeGroups ({commit, state}, payload) {
      return new Promise (async (resolve, reject) => {
        try {
          const { lskins } = payload;
          let endpoint = '/accounts/getPhonecodeGroups';

          let groups = await axios.post(endpoint, {
            lskins: lskins
          });

          let phonecodeGroupAssoc = {}
          for (let group of groups.data) {
            let key = group.frn_lskinid;
            let val = group;
            phonecodeGroupAssoc[key] ? phonecodeGroupAssoc[key].push(val) : phonecodeGroupAssoc[key] = [val];
            phonecodeGroupAssoc['all'] ? phonecodeGroupAssoc['all'].push(val) : phonecodeGroupAssoc['all'] = [val];
          }

          commit({
            type: 'setPhonecodeGroups',
            phonecodeGroups: phonecodeGroupAssoc
          });

          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    mapPhonecodesToGroups ({commit, state}, payload) {
      return new Promise (async (resolve, reject) => {
        try {
          const { lskins } = payload;
          let endpoint = '/accounts/mapPhonecodesToGroups';

          let phonecodesToGroups = await axios.post(endpoint, {
            lskins: lskins
          });

          let phonecodesToGroupsMap = {};
          for (let phonecode of phonecodesToGroups.data) {
            let key = phonecode.phonecodeid;
            let val = phonecode.PhonecodeClassPcs.map( phonecodeClass => phonecodeClass.frn_phonecode_classid );
            phonecodesToGroupsMap[key] ? phonecodesToGroupsMap[key].concat(val) : phonecodesToGroupsMap[key] = val;
          }

          commit({
            type: 'setPhonecodesToGroupsMap',
            phonecodesToGroupsMap: phonecodesToGroupsMap
          });

          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      });
    },
    getAllAccounts ({commit, state}, payload) {
      return new Promise ( async (resolve, reject) => {
        try {
          const { lskins } = payload

          let url = '/accounts/'
          let accounts = await axios.post(url, {
            lskins: lskins
          })
    
          let accountAssoc = {}
          for (let account of accounts.data) {

            // get blocked numbers
            let thisRequest = {
              lskinid: [account.lskinid]
            }

            let hash = crypto.createHmac("sha256", state.secret)
              .update(JSON.stringify(thisRequest))
              .digest("hex");

            let blockedNumbers = await axios.post('https://texting.callbox.com/v2/api/blockedNumbers', thisRequest,
            {
              transformRequest: [
                (data, headers) => { 
                  delete headers.common.Authorization; return JSON.stringify(data)
                }
              ],
              headers: {
                'Content-Type': 'application/json',
                'Hash': hash
              },
            });

            account.blockedNumbers = blockedNumbers.data.map(number => number.CustomerNumber);

            let key = account.lskinid
            let val = account
            accountAssoc[key] = val
          }
    
          commit({
            type: 'setAccounts',
            accounts: accountAssoc
          })
  
          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })   
    },
    async getTrackingLineFiltering ({commit, state}, payload) {
      return new Promise ( async (resolve, reject) => {
        try {
          const { lskins } = payload;

          let url = '/dnis/callcenter'
          let lines = await axios.post(url, {
            lskins: lskins
          })

          const lineAssoc = {};
          for (let line of lines.data) {
            let key = line.dnisid;
            let value = true;
            lineAssoc[key] = value;
          }

          commit({
            type: 'setTrackingLineFilters',
            lines: lineAssoc
          })

          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async displayTextIfConversationOpen ({commit, state}, payload) {
      let msg = payload.msg;
      let attachmentData = payload.attachmentData;

      // Only append text if the current conversation opened is the one the text is from
      if (msg._id == state.conversation.conversationid) {
        // isSent update or ForwardedTo update -- don't push, jsut update
        if (msg.interaction.text._id == state.currentMessages[state.currentMessages.length - 1].id) {
          state.currentMessages[state.currentMessages.length - 1].sendStatus = msg.interaction.text.isSent == false ? 0 : 1;
          state.currentMessages[state.currentMessages.length - 1].forwardedTo = msg.interaction.text.forwardedTo;
        } else {
          let interaction = msg.interaction;
        
          commit({
            type: 'AddTextToConversation',
            frn_zwid: interaction.text.zwid,
            body: interaction.text.body,
            attachment: attachmentData,
            datetime: interaction.text.timestamp,
            lename: interaction.text.lename,
            pc_avatar: interaction.text.pc_avatar,
            phonecodeid: interaction.text.phonecodeid,
            label1: interaction.text.label1,
            displaynum: interaction.text.displaynum,
            direction: interaction.direction,
            textid: interaction.text._id,
            id: interaction.text._id,
            forwardedTo: interaction.text.forwardedTo,
            sendStatus: interaction.text.isSent
          })    
        }
      }
    },
    async displayNoteIfConversationOpen ({commit, state}, payload) {
      let msg = payload;

      if (msg._id == state.conversation.conversationid) {
        if (msg.interaction.note.text == state.currentMessages[state.currentMessages.length - 1].comment) {
          // Do nothing
        } else {
          let interaction = msg.interaction;

          commit({
            type: 'AddNoteToConversation',
            comment: interaction.note.text,
            leuserid: interaction.note.leuserid,
            username: interaction.note.username,
            phonecodeid: interaction.note.phonecodeid,
            pc_avatar: interaction.note.pc_avatar
          });
        }
      }
    },
    async liveListenManagerRole ({commit, state}, payload) {
      return new Promise ( async (resolve, reject) => {
        try {
          const hideLiveRoles = [
            "Multifamily: Leasing Staff",
            "Medical: Office Staff/Receptionist",
            "Car Wars: Other: Discovery User",
            "Rent Buzz: Other: Discovery User",
            "Automotive: Salesperson",
            "Automotive: BDC Agent/Rep",
            "Automotive: Service Advisor",
            "Automotive: Guest Services/Receptionist",
            "Automotive: Third Party Vendor",
            "Medical: Third Party Vendor",
            "Home Services: CSR (Customer Service Rep)",
            "Home Services: 3rd Party Marketing Vendor",
            "Other: Location Staff",
            "Other: ProMax"
          ]
          let endpoint = `/users/${payload}/roles`
          // console.log(endpoint);
          let res = await axios.get(endpoint, {})

          if (res.data) {
            if (!res.data.length || hideLiveRoles.includes(res.data[0].contact_role)) {
              commit({
                type: 'hideLiveButton',
                setting: false
              })

              commit({
                type: 'setSelectedFilter',
                selectedFilter: 'Following & New'
              })
            }
          }

          resolve();
        } catch(err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async checkCallCenterOutcomeEnabled({commit, state}, payload) {
      return new Promise ( async (resolve, reject) => {
        try {
          let lskinid = payload;
          let urlCallCenterCheckFeature = `/callcenterOutcome/${lskinid}/checkFeature`;

          let res = await axios.get(urlCallCenterCheckFeature);

          commit({
            type: 'setCallCenterOutcomeFeature',
            isEnabled: res.data === true ? true : false
          });

          return res.data === true ? resolve(true) : resolve(false);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async getCallCenterOutcomes({commit, state}, payload) {
      return new Promise ( async (resolve, reject) => {
        try {
          let lskinid = payload;
          let urlCallCenterOutcomes = `/callcenterOutcome/${lskinid}/outcomes`;
  
          let res = await axios.get(urlCallCenterOutcomes);
  
          commit({
            type: 'setCallCenterOutcomes',
            outcomes: res.data
          });
  
          return resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async populateConversation ({commit, state}, payload) {
      //console.log('PopConvo');
      //console.log(payload);
      if (payload.conversations.conversation !== undefined) {
        // If last call associated with convo hasn't finished call processing yet.
        // Need to check if it already exists in liveCallData, also need to check if last call actually does exist
        
        let currentConvo = state.inboxData.filter(obj => obj.conversationid === payload.conversationid)[0];

        // Get callid from GUID if applicable -- prevents duplicate calls showing up
        let callidFromGuidEndpoint = `/calls/guid/${currentConvo.interactionid}`;
        
        let res;
        let callidFromGuid;
        if (isNaN(currentConvo.interactionid) && currentConvo.interactionid.indexOf('-') > -1) {
          res = await axios.get(callidFromGuidEndpoint);
          callidFromGuid = res.data ? res.data : undefined;
        } else {
          callidFromGuid = currentConvo.interactionid;
        }

        let checkCallExists = payload.conversations.interactions.filter(obj => obj.callid == currentConvo.interactionid || (callidFromGuid && obj.callid == callidFromGuid));
        let checkLiveCallExists = state.liveCallData.filter(obj => obj.interactionid == currentConvo.interactionid);
        let interaction = payload.conversations.conversation.conversation.interaction.type;

        // Didn't receive call complete message in time before call processing finished the call, mark convo completed and remove, then sort
        if(interaction === 'Call' && checkCallExists.length && checkLiveCallExists.length) {
          // Mark conversation is completed, and then remove from liveCallData array
          let callPos = state.inboxData.findIndex(obj => obj.interactionid === currentConvo.interactionid)
          let popLiveCallData = state.liveCallData.filter(obj => obj.interactionid !== currentConvo.interactionid)

          state.liveCallData = popLiveCallData
    
          if (callPos >= 0) {
            state.inboxData[callPos].liveCall = false
    
            if (state.currentThread.conversationid === state.inboxData[callPos].conversationid) {
              state.currentThread.isLive = false
            }
          }

          commit('sortInbox')
        }

        if (interaction === 'Call' && !checkCallExists.length && !checkLiveCallExists.length) {
          let direction = currentConvo.type === 'IB' ? 1 : 2

          // console.log(currentConvo);
          let phonecodeObject = {};
          let agentObject = {};
          if (currentConvo.conversation.interaction.call.phonecodeid > 0) {
            phonecodeObject = {
              lename: currentConvo.conversation.interaction.call.lename,
              pc_avatar: currentConvo.conversation.interaction.call.pc_avatar ? `https://s3.amazonaws.com/callbox-images-external/avatars/${currentConvo.conversation.interaction.call.phonecodeid}.jpg` : currentConvo.conversation.interaction.call.pc_avatar,
              phonecodeid: currentConvo.conversation.interaction.call.phonecodeid
            }
            agentObject = {
              'Phonecode': phonecodeObject
            }
          } else {
            phonecodeObject = null;
            agentObject = null;
          }

          let callid = currentConvo.interactionid;
          let tempOutcomeEndpoint = `/callcenterOutcome/${callid}/display`;

          let outcomeRes = await axios.get(tempOutcomeEndpoint);

          payload.conversations.interactions.push({
            agent: agentObject,
            agentSelected: agentObject,
            ani: currentConvo.custNumber,
            audio: {
              audiofile: '',
              audiofileembed: '',
              recording_killed: false
            },
            audioCompression: null,
            callid: currentConvo.interactionid,
            date: moment(currentConvo.lastCommsDate).format('MMMM D, YYYY'),
            datetime: moment(currentConvo.lastCommsDate).format('MMMM D, YYYY h:mm A'),
            cf_frn_dnisid: currentConvo.conversation.interaction.call.dnisId,
            disposition: 'Answered',
            disposition_condensed: currentConvo.conversation.hcatCondensed === 'no recap' ? '' : currentConvo.conversation.hcatCondensed,
            displaynum: currentConvo.displayNum,
            dnis: {
              displaynum: currentConvo.displayNum,
              dnisfunctionid: direction,
              label1: currentConvo.tlInfo
            },
            dnis_extension: currentConvo.conversation.interaction.call.bridgeval,
            dnis_ringto: '',
            dnisfunctionid: currentConvo.type === 'IB' ? 1 : 2,
            duration: '',
            extension_frn_dnisid: currentConvo.conversation.interaction.call.extension,
            frn_xcall_dispositionid: 1,
            frn_phonecodeid: currentConvo.conversation.interaction.call.phonecodeid,
            lename: currentConvo.conversation.interaction.call.lename,
            islive: currentConvo.liveCall,
            inbound: (currentConvo.type === 'IB'),
            label1: currentConvo.conversation.dnisLabel,
            lednis: '',
            leminutes: '',
            outcome: Object.keys(outcomeRes.data).length ? outcomeRes.data.OutcomeText : '',
            outcome_by: Object.keys(outcomeRes.data).length ? outcomeRes.data.Descrip1 : '',
            outcome_on: Object.keys(outcomeRes.data).length ? outcomeRes.data.DateTime : '',
            pc_avatar: currentConvo.conversation.interaction.call.pc_avatar ? `https://s3.amazonaws.com/callbox-images-external/avatars/${currentConvo.conversation.interaction.call.phonecodeid}.jpg` : currentConvo.conversation.interaction.call.pc_avatar,
            spamrating: '',      
            note: null,
            sentimentNeg: false,
            sentimentPos: false,
            transcript: '',
            type: 1,
            nodeIP: currentConvo.conversation.interaction.call.asteriskIP
          })
        }

        commit({
          type: 'updateConversationData',
          conversation: payload.conversations
        })
      }

      commit({
        type: 'AddLiveCallToConversation',
        conversationid: payload.conversationid
      })

      commit({
        type: 'loadConversation',
        setting: false
      })

      commit({
          type: 'loadAll',
          setting: state.query45
      })
    },
    populateConversationAsync ({commit, state}, callids) {
      commit({
        type: 'asyncSummaries',
        callids: callids
      })

      commit({
        type: 'asyncDetails',
        callids: callids
      })
    },
    async populateResourcesAsync ({commit, state}, lskinid) {
      return new Promise ( async (resolve, reject) => {
        try {
          let endpoint = '/resource/'
          endpoint = endpoint + lskinid 
    
          let res = await axios.get(endpoint)

          if (res.data) {
            let resources = res.data

            commit({
              type: 'updateResources',
              resources: resources
            })

            commit({
              type: 'updateFilteredResources'
            })
          }

          resolve()
        } catch (e) {
          console.log(e)
          resolve(e)
        } 
      })
    },
    async populateCallCenterResourcesAsync ({commit, state}, lskinid) {
      return new Promise ( async (resolve, reject) => {
        try {
          let endpoint = '/resource/'
          endpoint = endpoint + lskinid 
    
          let res = await axios.get(endpoint)

          if (res.data) {
            let resources = res.data

            commit({
              type: 'updateCallCenterResources',
              resources: resources
            })

            commit({
              type: 'updateResources',
              resources: resources
            })

            commit({
              type: 'updateFilteredResources'
            })
          }

          resolve()
        } catch (e) {
          console.log(e)
          resolve(e)
        } 
      })
    },
    async logResourceEvent ({commit, dispatch, state}, resourceid) {
      return new Promise ( async (resolve, reject) => {
        try {
          let endpoint = '/resource/'
          endpoint = endpoint + resourceid + '/event';

          let userid = this.state.user.leuserid
          let conversationid = undefined

          if (this.state.currentThread.conversationid != 1234) {
            conversationid = this.state.currentThread.conversationid
          }

          let postBody = {
            conversationid: conversationid,
            userid: userid
          }

          await axios.post(endpoint, postBody);
          resolve()
        } catch (e) {
          console.log(e)
          reject(e)
        }
      }) 
    },
    async checkResourceEnabled ({commit, state}, lskinid) {
      return new Promise ( async (resolve, reject) => {
        try {
          let endpoint = `/resource/enabled/${lskinid}`;

          let res = await axios.get(endpoint);

          if (res.data) {
            commit({
              type: 'setResourceFlag',
              isEnabled: res.data
            })
          }

          resolve()
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async checkRedactionEnabled ({commit, state}, lskinid) {
      return new Promise ( async (resolve, reject) => {
        try {
          let endpoint = `/resource/redaction/${lskinid}`;

          let res = await axios.get(endpoint);

          if (res.data) {
            commit({
              type: 'setRedactionFlag',
              isEnabled: res.data
            })
          }

          resolve()
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async checkVinIntegrationEnabled ({commit, state}, lskins) {
      return new Promise ( async ( resolve, reject) => {
        try {
          let endpoint = `/integrations/vin/enabled`;

          let res = await axios.post(endpoint, {
            lskinids: lskins
          });

          const dealercodeMap = {};
          res.data.map(dealercode => {
            dealercodeMap[dealercode.LskinId] = dealercode.Dealercode;
          })

          commit('setVinDealercodeMappings', dealercodeMap);

          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async checkDSIntegrationEnabled({ commit, state }, lskins) {
      return new Promise(async (resolve, reject) => {
        try {
          let endpoint = `/integrations/ds/enabled`;

          let res = await axios.post(endpoint, {
            lskinids: lskins
          });

          const dealercodeMap = {};
          res.data.map(dealercode => {
            dealercodeMap[dealercode.LskinId] = dealercode.Dealercode;
          })

          commit('setDSDealercodeMappings', dealercodeMap);

          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async checkEleadIntegrationEnabled({commit, state }, lskins) {
      return new Promise(async (resolve, reject) => {
        try {
          let endpoint = `/integrations/elead/enabled`;

          let res = await axios.post(endpoint, {
            lskinids: lskins
          });

          const dealercodeMap = {};
          res.data.map(dealercode => {
            dealercodeMap[dealercode.LskinId] = dealercode.Dealercode;
          })

          commit('setEleadDealercodeMappings', dealercodeMap);

          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })

    },
    async checkJiveIntegrationEnabled ({commit, state}, leuserid) {
      return new Promise ( async ( resolve, reject) => {
        try {
          const res = await axios.get(`/integrations/jive/${leuserid}`);

          const jiveLskins = [];
          res.data.map(lskins => {
            jiveLskins.push(parseInt(lskins.lskinid));
          });

          commit('setJiveLskins', jiveLskins);

          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async checkNexhealthIntegrationEnabled ({commit, state}, lskins) {
      return new Promise ( async ( resolve, reject) => {
        try {
          let endpoint = `/integrations/nexhealth/enabled`;

          let res = await axios.post(endpoint, {
            lskinids: lskins
          });


          const nexhealthLskins = [];
          res.data.map(lskins => {
            nexhealthLskins.push(parseInt(lskins.lskinid));
          });

          commit('setNexhealthLskins', nexhealthLskins);

          resolve();
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })
    },
    async markAddressed ({commit, state}, timestamp) {
      timestamp = moment(timestamp);

      const messages = this.state.currentMessages.map(message => {
        if (timestamp.diff(moment(message.tz_datetime)) >= 0) {
          message.Unaddressed = false;
        }
        return message;
      })

      commit('markMessagesAddressed', messages);
    },
    async getCallmeasurementAPIToken ({commit, state}) {
      try {
        const res = await axios.get('/users/callmeasurement/jwt');

        if (res.data) {
          commit('setCallmeasurementAPIToken', res.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getCampaignData ({commit, state}, payload) {
      try {
        const res = await axios.get(`/users/${payload.leuserid}/${payload.lskinid}/campaigns`);

        // Process data
        if (res.data) {
          const tempCampaigns = [];
          const tempAniCampaignMap = {};
          for (const campaign of res.data.campaigns) {
            tempCampaigns.push({
              name: campaign.campaignName,
              id: campaign.campaignid,
              callsRemaining: campaign.Remaining,
              callsTotal: campaign.RemainingFull,
              associatedLskin: campaign.lskinid,
              callsRejected: campaign.Removed,
              calls: res.data.contacts[campaign.campaignid] || [],
              column1: campaign.Column1,
              column2: campaign.Column2,
              column3: campaign.Column3,
              column4: campaign.Column4,
              column5: campaign.Column5,
              column6: campaign.Column6,
              column7: campaign.Column7,
              column8: campaign.Column8,
              column9: campaign.Column9,
              column10: campaign.Column10,
              storedCampaignIndex: 0,
              visible: true
            })
          }

          for (const campaign in res.data.allContacts) {
            for (const contact of res.data.allContacts[campaign]) {
              const cleanedNumber = contact.CustomerNumber.replace(/[^0-9]/g, '');
              if (tempAniCampaignMap[cleanedNumber]) {
                tempAniCampaignMap[cleanedNumber].push(contact);
              } else {
                tempAniCampaignMap[cleanedNumber] = [contact];
              }
            }
          }

          commit('setCampaigns', tempCampaigns);
          commit('setAniCampaignMap', tempAniCampaignMap);
        }
      } catch (err) {
        console.log(err);
      }
    },
  }
})
